import React from 'react';
import { Button } from '@mui/material';

import { IKeyCap } from './interfaces';
import { useStyles } from './styles';

/**
 * Renders a single, static keyboard key visual (e.g. for "press T" hints).
 * Purely decorative — not clickable.
 *
 * @param props.label - Character shown on the key.
 * @param props.size - Key's width/height in pixels; defaults to 30.
 */
const KeyCap = ({ label, size = 30 }: IKeyCap) => {
  const classes = useStyles(size);

  return (
    <Button disableRipple sx={classes.button}>
      {label}
    </Button>
  );
};

export default KeyCap;
